import {Paper} from "@mui/material";
import BarekamText from "../../../pages/components/text";
import Message from "../../../pages/components/message";
import {MessageSections} from "../../../pages/components/message/message";

export const DashboardTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <Paper sx={{padding: '1rem'}}>
                <BarekamText variant={'m'} bold>
                    {label}
                </BarekamText>

                {payload.map((data: any) =>
                    <BarekamText variant={'m'}>
                        <Message messageKey={data.name} sectionId={MessageSections.ORDERS}/>: {data.payload[data.dataKey]}
                    </BarekamText>
                )}
            </Paper>
        );
    }

    return null;
};